/**
 * Crea el boton de sumar y su comportamiento
 * @param {*} scene
 */
export function crearBotonSumar(scene) {

  scene.botonSumarActivado = true;

  scene.botonSumar = scene.add
    .image(498, 418, "botonSumarActivado")
    .setInteractive();
    
  scene.botonSumar.on("pointerover", () => {
    if (!scene.noVaMas){
      if (!scene.botonSumarActivado) {
        scene.botonSumar.setTexture("botonSumarDesactivadoHover");
      }
    }
  });

  scene.botonSumar.on("pointerout", () => {
    if(!scene.noVaMas){
      if (!scene.botonSumarActivado) {
        scene.botonSumar.setTexture("botonSumarDesactivado");
      }
    }
  });

  scene.botonSumar.on("pointerdown", () => {
    if (!scene.noVaMas) {
      if (!scene.botonSumarActivado) {
        scene.botonSumar.setTexture("botonSumarDesactivadoPressed");
      }
    }
  });

  scene.botonSumar.on("pointerup", () => {

    if(!scene.noVaMas){
      if (!scene.botonSumarActivado) {

        scene.botonSumarActivado = true;
        scene.botonRestar.setTexture("botonRestarDesactivado");
  
        if (scene.botonSumar.input?.isOver) {
          scene.botonSumar.setTexture("botonSumarActivado");
        } else {
          scene.botonSumar.setTexture("botonSumarActivado");
        }
      }
    }
  });
}
